import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGetTodosQuery } from "../rtk/features/api/apiSlice";
import Todo from "./Todo";

const queryStatusString = (status) => {
  switch (status) {
    case "Complete":
      return true;

    case "Incomplete":
      return false

    default:
      return "";
  }
};

const queryColorsString = (colors) => {
  if(colors?.length > 0) {
    const likes = colors.map((color) => `color_like=${color}`);
    const result = `&${likes.join("&")}`;
    return result;
  }else {
    return '';
  }
};

export default function TodoList({ isComplete }) {
  const [request,setReuest] = useState(false);
  const { status, colors } = useSelector((state) => state.filters);
  const {
    data: todos,
    isLoading,
    isError,
  } = useGetTodosQuery(`?completed_like=${queryStatusString(status)}${queryColorsString(colors)}`, {
    skip: !request,
  });

  useEffect(() => {
    if(status || colors) {
      setReuest(true);
    }
  }, [status, colors]);

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <h2>Loading...</h2>;
  }

  if (!isLoading && isError) {
    content = <h2>There was an error</h2>;
  }

  if (!isLoading && !isError && todos?.length === 0) {
    content = <h2>No todos found!</h2>;
  }

  if (!isLoading && !isError && todos?.length > 0) {
    content = todos.map((todo) => <Todo todo={todo} key={todo.id} setReuest={setReuest} />);
  }

  return (
    <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
      {content}
    </div>
  );
}
